"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Settings_1 = __importDefault(require("configs/Settings"));
const SalesConstants_1 = require("./SalesConstants");
const request_1 = __importDefault(require("@hotmart/request"));
request_1.default.register(`${Settings_1.default.api.salesSettings}/v4/`, {
    get: {
        [SalesConstants_1.SalesEndpointKeys.GetSalesInfo]: 'info',
        [SalesConstants_1.SalesEndpointKeys.GetOffers]: 'offers',
        [SalesConstants_1.SalesEndpointKeys.GetMainOffers]: 'offers/mainOffers',
        [SalesConstants_1.SalesEndpointKeys.GetMembershipClassAndOffersBySubdomain]: 'membershipClass/offers',
        [SalesConstants_1.SalesEndpointKeys.GetGroupsInfo]: 'groups'
    },
    put: {
        [SalesConstants_1.SalesEndpointKeys.PutSalesInfo]: 'info',
        [SalesConstants_1.SalesEndpointKeys.PutGroupsInfo]: 'groups'
    },
    post: {
        [SalesConstants_1.SalesEndpointKeys.PostUserAreaEvent]: 'user-area/event'
    }
});
request_1.default.register(`${Settings_1.default.api.salesSettings}/v1/`, {
    get: {
        [SalesConstants_1.SalesEndpointKeys.GetSalesDiaglogAlert]: 'dialog/alert/show',
        [SalesConstants_1.SalesEndpointKeys.GetSalesCampaign]: 'campaign',
        [SalesConstants_1.SalesEndpointKeys.GetSalesCampaignAmount]: 'campaign/:campaignId/sales-amount'
    },
    post: {
        [SalesConstants_1.SalesEndpointKeys.PostSalesCampaignActivate]: 'campaign/:campaignId/activate',
        [SalesConstants_1.SalesEndpointKeys.PostSalesCampaignInactivate]: 'campaign/:campaignId/inactivate'
    }
});
request_1.default.register(`${Settings_1.default.api.clubSettings}/v4/`, {
    get: {
        [SalesConstants_1.SalesEndpointKeys.GetSignupAllowed]: 'membership/signup-allowed',
        [SalesConstants_1.SalesEndpointKeys.GetAccessPlusShow]: 'membership/config/access-plus/show',
        [SalesConstants_1.SalesEndpointKeys.GetIsAccessPlus]: 'membership/config/MEMBERSHIP_GROUPS_ENABLED/exists'
    },
    post: {
        [SalesConstants_1.SalesEndpointKeys.PostSignupAllowed]: 'membership/signup-allowed'
    },
    put: {
        [SalesConstants_1.SalesEndpointKeys.PutConfigAdd]: 'membership/config/add'
    },
    delete: {
        [SalesConstants_1.SalesEndpointKeys.DeleteConfig]: 'membership/config/remove'
    }
});
request_1.default.register(`${Settings_1.default.api.display}/`, {
    post: {
        [SalesConstants_1.SalesEndpointKeys.PostFreeSignup]: 'memberships/:subdomain/freesignup/sales'
    }
});
